<template>
    <div class="row">
        <div class="col" v-if="isLoading">
            <card>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']"
                                                                 spin></font-awesome-icon></span></h1>
            </card>
        </div>
        <div class="col-sm-12 col-md-6" v-if="!isLoading" v-for="bulletin in bulletins"
             :key="bulletin.name">
            <BulletinCard :initialBulletin="bulletin"
                          v-on:remove="loadBulletins" v-on:save=""></BulletinCard>
        </div>

    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";
    import swal from 'sweetalert2';
    import BulletinCard from "./BulletinCard";

    export default {
        name: "BulletinGrid",
        components: {
            BulletinCard: BulletinCard,
            swal,
        },
        computed: {
            ...mapFields(`bulletin`, ['bulletins']),
        },
        data() {
            return {
                isLoading: true,
                inputVisible: false,
                inputValue: [],
                removing: [],
                showCreateModal: false,
                showAddButtonModal: false,
                selectedBulletin: null,
            };
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            save(gIndex) {
                this.saving.splice(gIndex, 1, true);
            },
            handleNameInputChange(gIndex, value) {
                let name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
                this.dirty.splice(gIndex, 1, true);
            },
            loadBulletins() {

                if (this.$store.getters['bulletin/needUpdate']) {
                    this.isLoading = true;
                    this.$store.dispatch('bulletin/load').then(() => {
                        this.localBulletins = this.bulletins;
                        this.dirty = [];
                        this.names = [];
                        this.saving = [];
                        this.localBulletins.forEach(g => {
                            this.dirty.push(false);
                            this.names.push(g.name);
                            this.saving.push(false);
                        });
                        this.isLoading = false;
                    })
                }
            },
        },
        mounted() {
            this.loadBulletins();
        },
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
